import { IRootState, ISubscription, ISubscriptionsState, IPlan } from '@/@types'

import CONSTANTS from '@/constants'
import { GetterTree } from 'vuex'
import store from '@/store'

const getters: GetterTree<ISubscriptionsState, IRootState> = {
  activeSubscriptions: state => {
    return (state.usersCurrentSubscriptionsWithPasses || []).filter(sub => sub.state === 'active')
  },
  skillDiveSubscription: (state, subscriptionsGetters) => {
    const { activeSubscriptions }: { activeSubscriptions: ISubscription[] } = subscriptionsGetters
    return activeSubscriptions.find((sub: ISubscription) => {
      return CONSTANTS.SKILL_DIVE_PLANS.includes(sub.plan_code)
    })
  },
  userHasSkillDive: (state, subscriptionsGetters) => {
    const { skillDiveSubscription }: { skillDiveSubscription: ISubscription } = subscriptionsGetters
    return !!skillDiveSubscription
  },
  hasSkillDiveCyberSecurity: (state, subscriptionsGetters) => {
    const { skillDiveSubscription }: { skillDiveSubscription: ISubscription } = subscriptionsGetters
    return (
      skillDiveSubscription?.passes?.data?.some(
        pass => pass.addon_code === CONSTANTS.SKILL_DIVE_LEARNING_AREAS.CYBER_SECURITY
      ) || false
    )
  },
  hasSkillDiveNetworking: (state, subscriptionsGetters) => {
    const { skillDiveSubscription }: { skillDiveSubscription: ISubscription } = subscriptionsGetters

    return (
      skillDiveSubscription?.passes?.data?.some(
        pass => pass.addon_code === CONSTANTS.SKILL_DIVE_LEARNING_AREAS.NETWORKING
      ) || false
    )
  },
  hasSkillDiveCloud: (state, subscriptionsGetters) => {
    const { skillDiveSubscription }: { skillDiveSubscription: ISubscription } = subscriptionsGetters
    return (
      skillDiveSubscription?.passes?.data?.some(
        pass => pass.addon_code === CONSTANTS.SKILL_DIVE_LEARNING_AREAS.CLOUD
      ) || false
    )
  },
  hasSkillDiveFullLearningAreas: (state, subscriptionsGetters) => {
    const { hasSkillDiveCyberSecurity, hasSkillDiveNetworking, hasSkillDiveCloud } =
      subscriptionsGetters
    return hasSkillDiveCyberSecurity && hasSkillDiveNetworking && hasSkillDiveCloud
  },
  getPaymentEntries: state => {
    return state?.paymentEntries ?? null
  },
  getUsersCurrentSubscriptions: state => {
    return state.usersCurrentSubscriptions
  },
  getUserHasSubscription: state => {
    // TODO: update all occurrences of userHasSubscription to this new getter
    return state.usersCurrentSubscriptions.length > 0
  },

  userHasFundamentalsMonthly: (state, subscriptionsGetters) => {
    const { getUsersCurrentSubscriptions }: { getUsersCurrentSubscriptions: Array<IPlan> } =
      subscriptionsGetters
    return !!getUsersCurrentSubscriptions?.find(
      (sub: IPlan) => CONSTANTS.PLANS.MONTHLY === sub.plan_code
    )
  },

  userHasFundamentalsAnnual: (state, subscriptionsGetters) => {
    const { getUsersCurrentSubscriptions }: { getUsersCurrentSubscriptions: Array<IPlan> } =
      subscriptionsGetters
    return !!getUsersCurrentSubscriptions?.find(
      (sub: IPlan) => CONSTANTS.PLANS.ANNUAL === sub.plan_code
    )
  },
  userHasPremium: (state, subscriptionsGetters) => {
    const { getUsersCurrentSubscriptions }: { getUsersCurrentSubscriptions: Array<IPlan> } =
      subscriptionsGetters
    return getUsersCurrentSubscriptions?.some((sub: IPlan) =>
      Object.values(CONSTANTS.PREMIUM_PLANS).includes(sub.plan_code || '')
    )
  },
  isPremiumPlusEnabledForUser: (_, subscriptionsGetters) => {
    /**
     * This getter is used to determine if the Premium Plus plan is enabled for the user.
     * Anonymous users = enabled
     * All users = enabled if Premium Plus is turned on && user has no subscription && user has no Skill Dive
     * B2B users = disabled
     */
    const isPremiumPlusEnabled = store.getters['featureFlags/premiumPlusEnabled']
    const isAuthenticated = store.getters['auth/isAuthenticated']
    const getUserHasSubscription = store.getters['subscriptions/getUserHasSubscription']
    const userHasSkillDive = subscriptionsGetters.userHasSkillDive
    const isBussinessUser = store.getters['business/isBusinessUser']

    if (!isAuthenticated) {
      return isPremiumPlusEnabled
    }
    return isPremiumPlusEnabled && !getUserHasSubscription && !userHasSkillDive && !isBussinessUser
  },
  getPaymentMethod: state => {
    return state.paymentMethod
  },
}

export default getters
